/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Swap_Deferred_TagInputs */

const en_us2_workout_swap_deferred_tag = /** @type {(inputs: Workout_Swap_Deferred_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`later`)
};

const pt_br2_workout_swap_deferred_tag = /** @type {(inputs: Workout_Swap_Deferred_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`depois`)
};

const es_419_workout_swap_deferred_tag = /** @type {(inputs: Workout_Swap_Deferred_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`después`)
};

const pt_pt2_workout_swap_deferred_tag = /** @type {(inputs: Workout_Swap_Deferred_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`depois`)
};

const fr_fr2_workout_swap_deferred_tag = /** @type {(inputs: Workout_Swap_Deferred_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plus tard`)
};

const de_de2_workout_swap_deferred_tag = /** @type {(inputs: Workout_Swap_Deferred_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`später`)
};

const it_it2_workout_swap_deferred_tag = /** @type {(inputs: Workout_Swap_Deferred_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dopo`)
};

/**
* | output |
* | --- |
* | "later" |
*
* @param {Workout_Swap_Deferred_TagInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_deferred_tag = /** @type {((inputs?: Workout_Swap_Deferred_TagInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Deferred_TagInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_deferred_tag(inputs)
	if (locale === "es-419") return es_419_workout_swap_deferred_tag(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_deferred_tag(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_deferred_tag(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_deferred_tag(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_deferred_tag(inputs)
	return en_us2_workout_swap_deferred_tag(inputs)
});
export { workout_swap_deferred_tag as "workout-swap.deferred_tag" }